import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  readTime: number;
  publishedAt: string;
  imageUrl: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  readTime,
  publishedAt,
  imageUrl,
}: ArticleCardProps) {
  const cat = categories.find((c) => c.slug === category);
  const categoryName = cat?.name || category;

  return (
    <article className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            title={title}
          />
        </div>
        <div className="p-4 md:p-5">
          <div className="flex items-center gap-3 mb-2">
            <span className="text-xs bg-secondary-100 text-secondary-800 px-2 py-1 rounded-full whitespace-nowrap">
              {categoryName}
            </span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              {readTime} 分钟阅读
            </span>
          </div>
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
            {excerpt}
          </p>
          <div className="mt-3 flex items-center justify-between">
            <span className="text-xs text-foreground-400">{publishedAt}</span>
            <span className="text-xs text-primary-600 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              阅读全文 <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}